import config from '../../config'
import { HTTP } from  '../../http'
import moment from 'moment'

const pageSize = 5
const transactionsEntryPointUri = config.apiEndpoints.transactionEntryPointUri
const transactionsUri = config.apiEndpoints.transactionsUri
const balanceUri = config.apiEndpoints.balanceUri

export function queryStringParams(request) {
    request.startDate = request.startDate == '' ?  '' : moment(request.startDate).format('YYYY-MM-DDTHH:mm:ss');
    request.endDate = request.endDate == '' ?  '' : moment(request.endDate).format('YYYY-MM-DDTHH:mm:ss');
    const sellerId = request.sellerId == '' ? '' : `&sellerId=${request.sellerId}`;
    const salesPersonId = request.salesPersonId == '' ? '' : `&salesPersonId=${request.salesPersonId}`;
    const hasInstallments = request.hasInstallments == '' ? '' : `&hasInstallments=${request.hasInstallments}`;
    const origin = request.origin == '' ? '' : `&origin=${request.origin}`;
    return `partnerId=${request.partnerId}&startDate=${request.startDate}&endDate=${request.endDate}&paymentMethodTypeId=${request.paymentMethodTypeId}&deviceSerialNumber=${request.deviceId}&paymentMethodId=${request.paymentMethodId}${sellerId}${salesPersonId}${hasInstallments}${origin}`;
}

export function queryStringParamsWithPage(request, page, pageSize) {
    return `${queryStringParams(request)}&page=${page}&pageSize=${pageSize}`;
}
export default {
    find: (id) =>{
        return new Promise((resolve, reject) => {
            HTTP.get(`${transactionsEntryPointUri}${id}`).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },    
    findAllExport: (request) => {        
        return new Promise((resolve, reject) => {
            HTTP.get(`${transactionsUri}search/export?${queryStringParams(request)}`,
            {
                responseType: 'blob'
            }
            )
            .then(response => {
                let blob = new Blob([response.data], { type: 'text/csv' });
                let url = window.URL.createObjectURL(blob);
                resolve(url);               
            }, error => {
                reject(error);
            })
        });        
    },
    findAll: (request, page) => {
        const url = `${transactionsEntryPointUri}search?${queryStringParamsWithPage(request, page, pageSize)}`;
        return new Promise((resolve, reject) => {
            HTTP.get(url)
            .then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    forecast: (request, page) => {
        const url = `${transactionsEntryPointUri}forecast?${queryStringParamsWithPage(request, page, pageSize)}`;
        return new Promise((resolve, reject) => {
            HTTP.get(url)
            .then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    forecastExport: (request) => {        
        return new Promise((resolve, reject) => {
            HTTP.get(`${transactionsUri}forecast/export?${queryStringParams(request)}`,
            {
                responseType: 'blob'
            }
            )
            .then(response => {
                console.log(response)    
                let blob = new Blob([response.data], { type: 'text/csv' });
                let url = window.URL.createObjectURL(blob);
                resolve(url);               
            }, error => {
                reject(error);
            })
        });        
    },
    summary: (request) => {
        const url = `${transactionsEntryPointUri}summary?${queryStringParams(request)}`;
        return new Promise((resolve, reject) => {            
            HTTP.get(url)
            .then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    balance: (request) => {
        return new Promise((resolve, reject) => {  
            const customerType = request.customerType == '' ? '' : `&businessType=${request.customerType}`;          
            HTTP.get(`${balanceUri}?customerId=${request.customerId}${customerType}`)
            .then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    addCash: (sellerId, amount) => {
        return new Promise((resolve, reject) => {
            HTTP.post(`${transactionsEntryPointUri}addCash`, { sellerId: sellerId, amount: amount }).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
}